/*
 * sT3r
 */
$(document).ready(function() {


  $('.slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: '</button><button type="button" class="slick-prev "><img alt="prev arrow" src="/typo3conf/ext/st3r_template/Resources/Public/Images/pfeil_w_l.png" width="28" height="51"></button>',
    nextArrow: '<button type="button" class="slick-next "><img alt="next arrow" src="/typo3conf/ext/st3r_template/Resources/Public/Images/pfeil_w_r.png" width="28" height="51"></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 3,
          //centerMode:true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          //centerMode:true
        }
      }
    ]
  });

  if($('.om-news-list').length > 0){
    var masonery = $('.om-news-list').masonry({
      // use element for option
      columnWidth: '.om-news-list__item',
      itemSelector: '.om-news-list__item',
      gutter: '.gutter-sizer',
      percentPosition: true,
      transitionDuration: 0
    })
  }
  initFixedHeader();
  initMobileMenu();
  initFancybox();
  initSmallLayoutAnimations();
  initLoadmoreNewsAndMasonery();
});

$(window).on('resize', function () {
  initFixedHeader();
});

// $(window).on('load', function () {
//   if($('.om-news-list').length > 0){
//     $('.om-news-list').masonry({
//       // use element for option
//       columnWidth: '.om-news-list__item',
//       percentPosition: true,
//       gutter: '.gutter-sizer'
//     })
//   }
// });

//FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
var vh = window.innerHeight * 0.01;
//this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', vh+'px');